import React from 'react'
import { PreviewBlock } from 'planetyze-ui'
import classNames from 'classnames'

const PageBlock = (props) => {
  const { id, title, subtitle, children, className, preview = false, t } = props

  if (!children) {
    return null
  }

  const classes = classNames('page-block mb-24', className)

  return (
    <div id={id} className={classes}>
      {title && (
        <h3
          className='page-block-title text-3xl font-semibold font-sans text-center text-left  mb-2'
          children={title}
        />
      )}

      {title && (
        <div className='border-b-2 border-primary w-10 mx-auto  mb-12' />
      )}
      {subtitle && <div>{subtitle}</div>}
      <div>
        {preview ? <PreviewBlock children={children} t={t} /> : children}
      </div>
    </div>
  )
}

export default PageBlock
